import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { BusinessPartnersComponent } from "./business-partners.component";
import { ProspectsPopupComponent } from "./prospects-popup/prospects-popup.component";
const routes: Routes = [
    { path: '', component: BusinessPartnersComponent },
    { path: 'create', component: ProspectsPopupComponent },
    { path: 'view', component: ProspectsPopupComponent }
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class BusinessPartnersRoutingModule { }
